import {QuoteApiDto} from "../../api/model/rest";
import Attachment from "../attachment/Attachment";

export default class QuotePreview {

	constructor(public readonly id: string,
		public readonly referenceNumber: string,
		public readonly leadId: string,
		public readonly attachments: Attachment[]) {}

	public static fromJson(json: QuoteApiDto, leadId: string): QuotePreview {
		return new QuotePreview(json.id, json.referenceNumber, leadId, json.attachments.map(Attachment.fromJson));
	}

	copy({attachments = this.attachments}): QuotePreview {
		return new QuotePreview(this.id, this.referenceNumber, this.leadId, attachments)
	}
}